import axios from 'axios';
import { ProductImage } from 'types';

export const fetchProductImages = (brandId: number, productId: number) => {
  return axios.get<ProductImage[]>(
    `/api/brands/${brandId}/products/${productId}/images`
  );
};
